import {Section, Box, Text} from '@primer/react-brand/esm'
import {LogoTiles} from '../../_components/LogoTiles/LogoTiles'

import styles from './HeroSection.module.css'

import type {HeroSectionContent} from '../../content'

import {HeroIntro} from './HeroIntro'
import {HeroCarousel} from './HeroCarousel'

type Props = {
  contentfulContent: HeroSectionContent
}

export function HeroSection(props: Props) {
  const {contentfulContent} = props

  const sectionId = contentfulContent.section.fields.htmlId

  const intro = contentfulContent.intro
  const carousel = contentfulContent.carousel
  const logoTiles = contentfulContent.logoTiles
  const logoTilesHeading = logoTiles?.fields.heading

  return (
    <Section id={sectionId} className={styles.HeroSection}>
      {intro ? <HeroIntro contentfulContent={intro} /> : null}
      {carousel ? <HeroCarousel items={carousel} heading={intro?.fields.heading} /> : null}

      {logoTilesHeading ? (
        <Box paddingBlockStart="spacious" paddingBlockEnd="normal" style={{textAlign: 'center'}}>
          <Text font="monospace" variant="muted" className={styles.LogoTilesHeading}>
            {logoTilesHeading}
          </Text>
        </Box>
      ) : null}
      <LogoTiles location="hero" />
    </Section>
  )
}
